module.exports = __webpack_public_path__ + "static/media/mastercard_logo.88749ccc.svg";